module.exports = require('./src/ReactS3');
